import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import { COMPANY } from '../constants/company'

export default function Termos() {
  return (
    <div className="min-h-screen bg-white text-black">
      <SEO
        title="Termos de Uso"
        description="Termos de Uso da plataforma WaitHere. Leia as condições de uso dos nossos serviços de gestão para restaurantes."
        path="/termos"
      />
      <nav className="sticky top-0 z-50 bg-white/97 backdrop-blur-md border-b border-neutral-200">
        <div className="flex items-center justify-between px-5 py-4 md:px-10 lg:px-16">
          <Link to="/" className="no-underline">
            <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
          </Link>
          <Link
            to="/"
            className="text-sm text-neutral-500 no-underline hover:text-black transition-colors"
          >
            ← Voltar ao início
          </Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-5 py-16 sm:px-8 lg:px-0">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">Termos de Uso</h1>
        <p className="text-neutral-400 text-sm mb-10">Última atualização: 29 de março de 2026</p>

        <div className="prose prose-neutral max-w-none space-y-6 text-[15px] leading-relaxed text-neutral-700">
          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">1. Aceitação dos termos</h2>
            <p>
              Ao acessar ou utilizar a plataforma {COMPANY.brandName} ("Serviço"), disponível em
              waithere.com.br (e wtr.app.br) e seus subdomínios, você concorda em cumprir e ficar vinculado a
              estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não
              deverá utilizar nosso Serviço.
            </p>
            <p>
              {COMPANY.brandName} é a marca comercial e plataforma operada pela {COMPANY.legalName}
              (CNPJ {COMPANY.cnpj}).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">2. Descrição do serviço</h2>
            <p>
              A WaitHere é uma plataforma de gestão digital para restaurantes e estabelecimentos
              alimentícios que oferece:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Cardápio digital com QR Code.</li>
              <li>Sistema de pedidos online (delivery, retirada e consumo no local).</li>
              <li>Gestão de mesas e comandas digitais.</li>
              <li>Criação de site personalizado para o estabelecimento.</li>
              <li>Painel de gestão e relatórios.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">3. Cadastro e conta</h2>
            <p>
              Para utilizar nossos serviços, você deve criar uma conta fornecendo informações
              verdadeiras, completas e atualizadas. Você é responsável por manter a
              confidencialidade de sua senha e por todas as atividades que ocorram em sua conta.
            </p>
            <p>
              Você deve nos notificar imediatamente sobre qualquer uso não autorizado de sua conta
              ou qualquer outra violação de segurança.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">4. Planos e pagamentos</h2>
            <p>
              A WaitHere oferece o plano Pro por 199/mês. Os detalhes do plano, incluindo
              funcionalidades e preços, estão disponíveis em nossa página de preços.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Os pagamentos são processados mensalmente, conforme o plano escolhido.</li>
              <li>Você pode cancelar sua assinatura a qualquer momento. O acesso continuará até o final do período já pago.</li>
              <li>Reservamo-nos o direito de alterar os preços com aviso prévio de 30 dias.</li>
            </ul>

            <h3 className="text-base font-semibold text-black mt-6 mb-2">4.1 Preço travado — Membros Fundadores</h3>
            <p>
              Restaurantes que aderirem ao plano Pro durante o período de lançamento ("Membros Fundadores") terão o valor de R$149/mês garantido enquanto mantiverem a assinatura ativa e contínua. Esse preço travado se aplica ao plano Pro na sua configuração atual.
            </p>
            <p className="mt-3">
              Novos recursos, módulos adicionais ou planos futuros poderão ter custo adicional. Nesse caso, Membros Fundadores terão sempre a opção de permanecer no plano atual pelo preço travado ou migrar voluntariamente para o novo plano, sem obrigação. Nenhuma mudança será aplicada de forma automática ou compulsória.
            </p>
            <p className="mt-3">
              O preço travado é perdido em caso de cancelamento voluntário da assinatura. A recontratação posterior estará sujeita ao preço vigente na época.
            </p>

            <h3 className="text-base font-semibold text-black mt-6 mb-2">4.2 Pagamentos online via Pix — Woovi</h3>
            <p>
              O recurso de pagamento online via Pix é processado pela Woovi (Woovi Instituição de Pagamento S.A.), parceira da WaitHere. Ao utilizar esse recurso, o estabelecimento concorda com os termos de uso da Woovi, disponíveis em woovi.com.
            </p>
            <p className="mt-3">
              A taxa de processamento é de no máximo R$1,00 por transação. Desse valor, aproximadamente 90% é repassado à Woovi como custo de processamento da transação — a WaitHere retém apenas o mínimo operacional. A taxa exata pode variar conforme condições negociadas com a Woovi e será sempre informada antes da ativação do recurso no painel.
            </p>
            <p className="mt-3">
              O recurso de pagamento online via Pix é opcional e pode ser ativado ou desativado a qualquer momento no painel do restaurante. Pedidos pagos diretamente no caixa (dinheiro, cartão presencial) não estão sujeitos a essa taxa.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">5. Uso aceitável</h2>
            <p>Ao utilizar nosso Serviço, você concorda em não:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Violar leis ou regulamentos aplicáveis.</li>
              <li>Publicar conteúdo ilegal, ofensivo ou que infrinja direitos de terceiros.</li>
              <li>Tentar acessar áreas não autorizadas da plataforma.</li>
              <li>Usar o Serviço para enviar spam ou comunicações não solicitadas.</li>
              <li>Realizar engenharia reversa ou tentar extrair o código-fonte da plataforma.</li>
              <li>Sobrecarregar intencionalmente nossa infraestrutura.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">6. Propriedade intelectual</h2>
            <p>
              Todo o conteúdo da plataforma WaitHere, incluindo mas não limitado a textos,
              gráficos, logotipos, ícones, imagens, código-fonte e software, é de propriedade
              da WaitHere ou de seus licenciadores e é protegido por leis de propriedade intelectual.
            </p>
            <p>
              O conteúdo que você criar na plataforma (cardápios, imagens de produtos, etc.) permanece
              de sua propriedade. Ao fazer upload, você nos concede uma licença limitada para exibir
              esse conteúdo conforme necessário para a prestação do Serviço.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">7. Limitação de responsabilidade</h2>
            <p>
              O Serviço é fornecido "como está" e "conforme disponível". Não garantimos que o
              Serviço será ininterrupto, seguro ou livre de erros. Em nenhuma circunstância a
              WaitHere será responsável por danos indiretos, incidentais, especiais ou consequenciais
              resultantes do uso ou da impossibilidade de uso do Serviço.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">8. Rescisão</h2>
            <p>
              Podemos suspender ou encerrar sua conta se você violar estes Termos de Uso. Você pode
              encerrar sua conta a qualquer momento entrando em contato com nosso suporte.
            </p>
            <p>
              Após o encerramento, seus dados serão mantidos por 30 dias para possível recuperação,
              após os quais serão permanentemente excluídos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">9. Alterações nos termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento.
              Alterações significativas serão comunicadas por e-mail ou por aviso na plataforma
              com pelo menos 15 dias de antecedência.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">10. Lei aplicável</h2>
            <p>
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Qualquer
              disputa será submetida ao foro da comarca de São Paulo, Estado de São Paulo.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mt-8 mb-3">11. Contato</h2>
            <p>
              Para dúvidas sobre estes Termos de Uso, entre em contato:
            </p>
            <ul className="list-none space-y-1 mt-3">
              <li><strong>Razão social:</strong> {COMPANY.legalName}</li>
              <li><strong>CNPJ:</strong> {COMPANY.cnpj}</li>
              <li><strong>E-mail:</strong> contato@waithere.com.br</li>
              <li>
                <strong>Instagram:</strong>{' '}
                <a
                  href="https://www.instagram.com/waithere.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black underline hover:text-neutral-500"
                >
                  @waithere.br
                </a>
              </li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  )
}
